import { Strong } from '@ahmdigital/ui';
import getIncomeTypeFromScale from '@ahmdigital/logic/lib/utils/get-income-type-from-scale';
import React from 'react';

import styles from './styles.module.sass';

// @ts-expect-error - Automatic, Please fix when editing this file
const getIncomeTypeText = (scale) => (getIncomeTypeFromScale(scale) === 'single' ? 'single income' : 'family income');

// @ts-expect-error - Automatic, Please fix when editing this file
const getValueText = (value, { max, min }) => {
  if (value < min) {
    return `Under $${min},000`;
  }
  if (value > max) {
    return `Over $${max},000`;
  }
  return `$${value},000`;
};

type MlsSliderTipProps = {
  limits: {
    max: number;
    min: number;
  };
  scale: string;
  value: number;
};

const MlsSliderTip = ({ limits, scale, value }: MlsSliderTipProps) => (
  <div>
    <div>
      <Strong variant={styles.value}>{getValueText(value, limits)}</Strong>
    </div>
    <div>{getIncomeTypeText(scale)}</div>
  </div>
);

export default MlsSliderTip;
export { getIncomeTypeText, getValueText };
